// Runtime config: Cloud Run env vars inyectadas via env-config.js (window.__ENV__)
// Fallback a process.env para desarrollo local (CRA lee .env en build time)
// eslint-disable-next-line no-underscore-dangle
const env = window.__ENV__ || {};

const config = {
  REACT_APP_NODE_API: env.REACT_APP_NODE_API || process.env.REACT_APP_NODE_API,
  REACT_APP_CLIENT_ID: env.REACT_APP_CLIENT_ID || process.env.REACT_APP_CLIENT_ID,
  REACT_APP_DEPLOYMENT: env.REACT_APP_DEPLOYMENT || process.env.REACT_APP_DEPLOYMENT,
};

export default config;
